<div class="modal-dialog p-0 overflow-scroll">
	<div class="content">
		<div class="mb-6">
			<h5 class="mb-0 font-medium text-[20px]">Preview</h5>
		</div>

		<div class="modal-body bg-black p-[15px] text-white">
			<div class="preview-group my-[25px]">
				<div class="preview-header">
					<mat-icon>android</mat-icon>
				</div>
				<div class="android-notification">
					<h4 class="notification-header">
						<mat-icon [inline]="true">photo_size_select_actual</mat-icon>
						Android System · 2min
					</h4>
					<h3 class="notification-title">{{ data.value.title }}</h3>
					<p class="notification-message">
						{{ data.value.message | slice : 0 : 150 }}
					</p>
					<div class="notification-image">
						<!-- <img [src]="image" alt="Notification Image" /> -->
					</div>
				</div>
			</div>

			<div class="preview-group">
				<div class="preview-header">
					<mat-icon>phone_iphone</mat-icon>
				</div>
				<div class="ios-notification">
					<h4 class="notification-header">
						<mat-icon [inline]="true">photo_size_select_actual</mat-icon>
						iOS Device
					</h4>
					<div class="notification-image">
						<img [src]="image" alt="Notification Image" />
					</div>
					<h3 class="notification-title">{{ data.value.title }}</h3>
					<p class="notification-message">
						{{ data.value.message | slice : 0 : 150 }}
					</p>
				</div>
			</div>
		</div>

		<div class="flex justify-between pt-6 px-6">
			<button [disableRipple]="true" mat-button class="cancel-button" (click)="cancel()">Cancel</button>
			<button [disableRipple]="true" mat-flat-button color="primary" class="send-button" (click)="confirm()">Send</button>
		</div>
	</div>
</div>
